import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";

const PayNowButton = ({ v }) => {
    // Get the payment URL from the stored details
    const paymentUrl = v?.acceptanceFee?.details?.paymentUrl;

    // Fetch payment gateway info for display name
    const { data: gatewayInfo } = useQuery({
        queryKey: ["paymentGateway"],
        queryFn: async () => {
            const req = await axiosget(`ms_payments/gateway`);
            return req?.data;
        },
    });

    const gateway = gatewayInfo?.data;

    const handlePayNow = () => {
        if (paymentUrl) {
            window.open(paymentUrl, "_blank");
        }
    };

    // Don't render if no payment URL
    if (!paymentUrl) return null;

    return (
        <button
            className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-3"
            onClick={handlePayNow}
        >
            <i className="fa fa-credit-card text-lg"></i>
            <span className="text-lg">Pay Now {gateway?.displayName ? `via ${gateway.displayName}` : ""}</span>
            <i className="fa fa-external-link text-sm"></i>
        </button>
    );
};

export default PayNowButton;
